import { FC } from 'react';
import { Location, Navigate, Outlet, useLocation } from 'react-router-dom';
import { User } from '../../utils/models';

import auth from '../../services/authService';
import routes from '../../utils/routes';

const PublicRoute: FC = (): JSX.Element => {
	const location: Location = useLocation();
	const user: User | null = auth.getCurrentUser();

	return user ? (
		<Navigate
			to={routes.dashboard.pathname}
			state={{ from: location.pathname }}
		/>
	) : (
		<Outlet />
	);
};

export default PublicRoute;
